import { render, staticRenderFns } from "./ManageColumnsSection.vue?vue&type=template&id=c014cf3a&scoped=true"
import script from "./ManageColumnsSection.vue?vue&type=script&lang=js"
export * from "./ManageColumnsSection.vue?vue&type=script&lang=js"
import style0 from "./ManageColumnsSection.vue?vue&type=style&index=0&id=c014cf3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c014cf3a",
  null
  
)

export default component.exports